import strFunc from "@/lib/lyg/string";

function SumTableArea(props: any) {
  let myProps = {
    infoArr:[],
    ...props
  };
  let sum_money=0;
  let infoArr = myProps.infoArr;
  if (infoArr.length > 0) {
    for(let i=0;i<infoArr.length;i++){
      let row_data=infoArr[i];
      sum_money+=parseInt(strFunc.uncomma(row_data["a_money"]));
    }
  }

  return (
    <div className="text-center mt-1">
      <div className="list-table-div mt-1" >
        <table style={{ width: "auto", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td>{infoArr.length} 건</td>
              <th>합계</th>
              <td>
                <div style={{ color: "green", fontWeight: "bold", minWidth: 100 }}>{strFunc.comma(sum_money)}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SumTableArea;